import React, { useState } from "react";

import { Box, CompassColor, Image } from "@noom/wax-component-library";

import { ASSET_URL } from "@/constants";
import { DPP_PARTNERS } from "@/constants/Partners";
import { useAppContext, useHeaderContext } from "@/contexts";
import { getDisplayName } from "@/models";
import { getAutologinData } from "@/utils/cookies";
import { isHighmarkPartner } from "@/utils/partners";

export const NoomHeader: React.FC<{ forceHeader?: boolean }> = ({
  forceHeader,
}) => {
  const { partnerInfo } = useAppContext();
  const { hideHeader } = useHeaderContext();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const autologinData = getAutologinData();

  if (!forceHeader && hideHeader) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  const showPartnerLogo = !isHighmarkPartner(partnerInfo) && partnerInfo?.slug;

  // Hide header if B2B WEA is loaded through a webview in the Noom app because the Noom app already loads its own header
  if (!forceHeader && autologinData) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <Box
      display="flex"
      gap="var(--spacing-s)"
      padding={{
        base: "var(--spacing-l) var(--spacing-m)",
        lg: "var(--spacing-l) var(--spacing-xl)",
      }}
    >
      <Image alt="Noom" height="16px" src="/assets/img/noom-logo-black.svg" />
      {showPartnerLogo && (
        <>
          <Box
            backgroundColor={CompassColor.black}
            width="2px"
            display={isImageLoaded ? "block" : "none"}
          />
          <Image
            alt={getDisplayName(partnerInfo)}
            height="16px"
            src={
              DPP_PARTNERS.includes(partnerInfo.id)
                ? `${ASSET_URL}/img/${partnerInfo?.slug}/logo-alt.png`
                : `${ASSET_URL}/img/${partnerInfo?.slug}/logo.png`
            }
            onLoad={() => setIsImageLoaded(true)}
            opacity={isImageLoaded ? 1 : 0}
            transition="opacity 0.1s ease-in-out"
          />
        </>
      )}
    </Box>
  );
};
